<template>
  <div class="name-wrapper">
    <p contenteditable="contenteditable" @input="updateInput">{{ content }}</p>
  </div>
</template>

<script>
export default {
  props: ['value'],
  data() {
    return { content: '' };
  },
  created() {
    this.content = this.value;
  },
  methods: {
    updateInput() {
      this.$emit('update:modelValue', this.$el.children[1].innerText);
    }
  }
};
</script>
<style lang="scss" scoped>
.name-wrapper {
  span {
    display: inline-block;
    margin-right: 10px;
    font-size: 12px;
    // font-weight: 600;
  }
  p {
    display: inline-block;
    // color: #000;
    color: #dfdfdf;
    font-size:  12px;
  }
}
</style>
